//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        src:{
            type:String,
            default:""
        },
        filename:{
            type:String,
            default:""
        }
    },
    data () {
        return{

        }
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    watch: {
        src(n, o) {
            if(!/pdf/i.test(n) && !/png|jpg/i.test(n) && !/doc/i.test(n) && !/xlsx|xls/i.test(n)){
                this.$nextTick(function(){
                    $("#download")[0].click();
                })
            }
        }
    },
    methods: {
        
    },
    mounted: function() {
        
        
    }
}
